export default class Gate {

    // v-if="$gate.isAdmin()"
    constructor(user) {
        this.user = user;
    }

    isAdmin() {
        return this.user.Role === 'Admin'
    }
    isReception() {
        return this.user.Role === 'Reception'
    }
    isAccount() {
        return this.user.Role === 'Account'
    }
    isManager() {
        return this.user.Role === 'Manager'
    }
    isSupervisor() {
        return this.user.Role === 'Supervisor'
    }
    isTeacher() {
        return this.user.Role === 'Teacher'
    }
    isUser() {
        return this.user.Role === 'User'
    }
}


// WEBPACK FOOTER //
// ./resources/js/Gate.js